import { DealStatusColors } from '@web-frontend/shared/components/deals/deal-status-manager/deal-status-manager-.const';

export namespace RmCalendar {
  export interface StorageControls {
    type: {
      deal: boolean;
      activity: boolean;
      absence: boolean;
    };
    showEndOfWeek: boolean;
    view: RmCalendar.View;
  }
  export type View = 'MONTH' | 'WEEK' | 'DAY';

  export const isEmptyHour = (date: Date) => {
    if (!date) {
      return true;
    }

    return (
      typeof date === 'object' &&
      !date.getHours() &&
      !date.getMinutes() &&
      !date.getSeconds()
    );
  };

  export const GetDefaultColor = (color: string) => {
    const colors = DealStatusColors;

    if (!color) {
      return {
        lightColor: '#F2F5FF',
        darkColor: '#D2DBFC',
      };
    }

    const currentColor = colors.find(
      (el) => el.lightColor.toLowerCase() === color?.toLowerCase()
    );

    if (currentColor) {
      return currentColor;
    }

    return {
      lightColor: '#F2F5FF',
      darkColor: '#D2DBFC',
    };
  };
}
